export default __webpack_public_path__ + "static/media/0017.e310e292.WAV";